import { getPaymentsApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type { GetOrCreatePaymentRequest, PaymentResponse } from '@/core/generated/api';

/** Выполняет этапы формирования платежа и ссылки на оплату */
export const paymentCreationService = {
    /** Возвращает предварительный расчёт заказа */
    async preview(orderId: string): Promise<PaymentResponse> {
        try {
            const response = await getPaymentsApi().getPaymentByOrderId({ orderId });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Создаёт платеж по заказу */
    async create(request: GetOrCreatePaymentRequest): Promise<PaymentResponse> {
        try {
            const response = await getPaymentsApi()
                .createPayment({
                    getOrCreatePaymentRequest: request,
                });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Проверяет, нужна ли ссылка для оплаты созданного платежа */
    async shouldGenerateUrl(paymentId: string): Promise<boolean> {
        try {
            const response = await getPaymentsApi().handleBeforeGeneratePaymentUrl({ paymentId });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Формирует ссылку для оплаты созданного платежа */
    async generateUrl(paymentId: string): Promise<string> {
        try {
            const response = await getPaymentsApi().generatePaymentUrl({ paymentId });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },
};
